import { RECORDING_IS_POPULAR_THRESHOLD } from '../constants';

export default function getRecordingIsPopular(recording) {
  return recording.popularity >= RECORDING_IS_POPULAR_THRESHOLD;
}
